<template>
  <div @click="handleSetMainAddress" :class="[address.is_main_address ? 'ecm__addresscard active' : 'ecm__addresscard']">
    <div class="ecm__addresscard-desc">
      <p>{{ address.receiver }}</p>
      <p>{{ address.phone_number }}</p>
      <p>{{ address.detail_address }}</p>
      <p>{{ address.province }}, {{ address.city }}, {{ address.postal_code }}</p>
    </div>
    <div class="ecm__addresscard-checked" v-if="address.is_main_address">
      <i class="fas fa-check-circle"></i>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Address_Card',
  props: {
    address: {
      type: Object,
      default: null
    }
  },
  methods: {
    handleSetMainAddress () {
      this.$emit('handleSetMainAddress', { addressId: this.$props.address.id })
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__addresscard {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px 5px 10px;
  border: 1px solid rgb(223, 223, 223);
  transition: .3s;
  border-radius: 3px;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.849);
  &:last-child {
    margin-bottom: 0;
  }
  .ecm__addresscard-desc {
    font-size: 15px;
    font-weight: 500;
  }
  .ecm__addresscard-checked {
    font-size: 20px;
  }
  &.active,
  &:hover {
    background: var(--color-blue-background);
    color: white;
    border: 1px solid var(--color-blue-background);
  }
}
</style>
